var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1756382779746,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 25863,
    width: 18,
    height: 18,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M464 736H192a80 80 0 0 1-80-80v-448A80 80 0 0 1 192 128h640a80 80 0 0 1 80 80v448A80 80 0 0 1 832 736h-272v64H768a32 32 0 0 1 32 32v32a32 32 0 0 1-32 32H256a32 32 0 0 1-32-32v-32a32 32 0 0 1 32-32h208v-64z m352-512h-608v416h608V224z m-448 96a32 32 0 0 1 32 32v208a32 32 0 0 1-32 32h-32a32 32 0 0 1-32-32V352a32 32 0 0 1 32-32h32z m320 48a32 32 0 0 1 32 32v160a32 32 0 0 1-32 32h-32a32 32 0 0 1-32-32v-160a32 32 0 0 1 32-32h32z m-160-96a32 32 0 0 1 32 32v256a32 32 0 0 1-32 32h-32a32 32 0 0 1-32-32v-256a32 32 0 0 1 32-32h32z",
    fill: "#374151",
    "p-id": 25864
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyboard);
export default __webpack_public_path__ + "static/media/myboard.29eb64ea.svg";
export { ForwardRef as ReactComponent };